var $db301acf5026b125$exports = {};
$db301acf5026b125$exports = {
    "info": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`,
    "negative": `\u{5E9}\u{5D2}\u{5D9}\u{5D0}\u{5D4}`,
    "positive": `\u{5D4}\u{5E6}\u{5DC}\u{5D7}\u{5D4}`
};


export {$db301acf5026b125$exports as default};
//# sourceMappingURL=he-IL.mjs.map
